import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import CollapsibleContainerEmptyState from './CollapsibleContainerEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MaybeLabeledContainer = ({
  isCollapsible = false,
  isLabeled = false,
  isEmpty = false,
  label,
  children
}) => {
  if (isCollapsible && label) {
    return /*#__PURE__*/_jsx(AccordionItem, {
      title: label,
      size: "md",
      defaultOpen: true,
      paddingInlineStart: "100",
      listStyleType: "none",
      contentStyles: {
        // Workaround for https://git.hubteam.com/HubSpot/foundations-components/issues/5494
        marginInlineStart: '-800',
        marginInlineEnd: '0'
      },
      children: isEmpty ? /*#__PURE__*/_jsx(CollapsibleContainerEmptyState, {}) : children
    });
  } else if (isLabeled && label) {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h4", {
        children: label
      }), /*#__PURE__*/_jsx(View, {
        paddingInline: "0",
        children: children
      })]
    });
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
};
export default MaybeLabeledContainer;